import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import { Button } from './ui/button';

export function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('tuliga_cookies_accepted');
    if (!cookiesAccepted) {
      // Show banner after a small delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('tuliga_cookies_accepted', 'true');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-[#0A0A0A] border border-white/10 rounded-2xl p-4 md:p-6 shadow-2xl shadow-black/50">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          {/* Icon and Text */}
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 rounded-xl bg-[#7C3AED]/20 flex items-center justify-center flex-shrink-0">
              <Cookie className="w-5 h-5 text-[#7C3AED]" />
            </div>
            <div>
              <h3 className="text-white font-semibold mb-1">🍪 Usamos cookies</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Utilizamos cookies para mantener tu sesión activa y mejorar tu experiencia en TuLiga.Online. 
                Al continuar navegando, aceptas nuestro{' '}
                <Link to="/privacy" className="text-[#7C3AED] hover:underline">
                  Aviso de Privacidad
                </Link>.
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-2 w-full md:w-auto">
            <Button
              onClick={acceptCookies}
              className="flex-1 md:flex-none bg-[#7C3AED] hover:bg-[#7C3AED]/80 text-white rounded-full px-6"
              data-testid="accept-cookies-btn"
            >
              Aceptar
            </Button>
            <button
              onClick={acceptCookies}
              className="p-2 text-gray-500 hover:text-white transition-colors"
              aria-label="Cerrar"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
